import React, { useState } from 'react'
import './select-pay.less'
import { List, Accordion } from 'antd-mobile'
import Checkbox from '@/components/checkbox/checkbox'

const Item = List.Item

interface Props {
  onChange: (type: string) => void
  payType?: string,
  style?:any
}

export default ({ onChange, payType,style }: Props) => {
  const [type, setType] = useState('alipay')
  if (payType) {
    if (type !== payType) {
      setType(payType)
    }
  }
  const change = (e: any, type: string) => {
    e.preventDefault()
    setType(type)
    onChange(type)
  }

  return (
    <Accordion style={style} defaultActiveKey="0" className="select-pay">
      <Accordion.Panel
        header={
          <div className="am-list-content">
            <span>支付方式</span>
            <span>{type === 'alipay' ? '支付宝' : '微信支付'}</span>
          </div>
        }
      >
        <List>
          <Item className="bag">
            <div onClick={e => change(e, 'alipay')} className="item">
              <div>
                <i className="iconfont zfb-icon">&#xe634;</i>
                <span className="icon-text ">支付宝</span>
              </div>
              <Checkbox checked={type === 'alipay'} />
            </div>
          </Item>
          <Item className="bag">
            <div onClick={e => change(e, 'wxpay')} className="item">
              <div>
                <i className="iconfont wx-icon">&#xe63d;</i>
                <span className="icon-text ">微信支付</span>
              </div>
              <Checkbox checked={type === 'wxpay'} />
            </div>
          </Item>
        </List>
      </Accordion.Panel>
    </Accordion>
  )
}
